import axios from "axios";
import { detallePreinscripcion } from "../api";
const actions = {
  setValidar: ({ commit }, datos) => {
    commit("validar", datos);
  },
  setCargandoRuta: ({ commit }, val) => {
    commit("setCargandoRuta", val);
  },
  fetchEstrategias: ({ commit }) => {
    return new Promise((resolve, reject) => {
      axios
        .get(detallePreinscripcion)
        .then(res => {
          console.log(res);
          commit("setEstrategias", res.data.results);
          resolve(res);
        })
        .catch(err => {
          console.error(err);
          console.error(err.response);
          reject(err);
        });
      // setTimeout(() => {}, 5000);
    });
  }
};

export default actions;
